import FormWizardTwoContainer from "../../../../Components/Forms/FormsLayout/FormWizardTwo/FormWizardTwo"

const FormWizardTwo = () => {
  return (
    <div className='page-body'>
      <FormWizardTwoContainer />
    </div>
  )
}

export default FormWizardTwo